import { combineReducers } from "redux";
import globalReducer from './Global/reducer';
import userReducer from './User/reducer';
import permissionReducer from './Function/reducer';
import lookuReducer from './lookup/reducer';
import internationalise from './Internationalise/reducer';
import clientReducer from './Client/reducer';
import documentReducer from './Documents/reducer';
import dashboardChart from './dashboard/reducer';
const rootReducer = combineReducers({
    client : clientReducer,
    global: globalReducer,
    owner: userReducer,
    permission: permissionReducer,
    lookup: lookuReducer,
    internationalise: internationalise,
    documents : documentReducer,
    chart: dashboardChart
});

export default rootReducer;